module.exports = __webpack_public_path__ + "static/customerbg3_mobile-36c0eb1bb11a8c4fcdff33efd0b2dd6e.png";